const i18nConfig = {
  locales: ['pl', 'en'],
  defaultLocale: 'pl'
};

module.exports = i18nConfig;
